import { CheckoutStrategyEnum } from './checkout-strategy.enum';

export interface ShopCheckoutResponseApi {
  CheckoutStrategy: string;
  SessionToken: string | null;
  RedirectUrl: string | null;
}

export type EskolareShopCheckoutResponse = {
  checkoutStrategy: CheckoutStrategyEnum.Eskolare;
  sessionToken: null;
  redirectUrl: string;
};

export type BemobiShopCheckoutResponse = {
  checkoutStrategy: CheckoutStrategyEnum.Bemobi;
  sessionToken: string | null;
  redirectUrl: null;
};

export type ShopCheckoutResponse =
  | EskolareShopCheckoutResponse
  | BemobiShopCheckoutResponse;

export type CheckoutExecuteParams = {
  response: ShopCheckoutResponse;
};

export function isEskolareShopCheckoutResponse(
  response: ShopCheckoutResponse
): response is EskolareShopCheckoutResponse {
  return response.checkoutStrategy === CheckoutStrategyEnum.Eskolare;
}

export function isBemobiShopCheckoutResponse(
  response: ShopCheckoutResponse
): response is BemobiShopCheckoutResponse {
  return response.checkoutStrategy === CheckoutStrategyEnum.Bemobi;
}
